import metadataSetExtension from "./extensions/metadataSet";

class MetadataSetModel {
  static accountState;

  id = 0;
  checked = false;
  name = '';
  enable = false;
  loginUrl = '';
  issuerUri = '';
  idpCertFileName = '';
  logoutUrl = '';
  idpCertFingerprint = '';
  rawData = {};

  constructor(rawData) {
    this.id = rawData.id;
    this.name = rawData.name;
    this.enable = rawData.enable;
    this.loginUrl = rawData.loginUrl || '';
    this.issuerUri = rawData.loginUrl || '';
    this.idpCertFileName = rawData.idpCertFileName || '';
    this.logoutUrl = rawData.logoutUrl || '';
    this.idpCertFingerprint = rawData.idpCertFingerprint || '';
    this.rawData = rawData;
  }

  get managedScopeLength() {
    return this.managedScope.length;
  }
}

for (const funcName in metadataSetExtension) {
  MetadataSetModel[funcName] = metadataSetExtension[funcName];
}

export default MetadataSetModel;